(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.storyScrollInitialized) return;
    window.storyScrollInitialized = true;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;

    // This theme uses `.page-wrapper` as the real scroll container at >=990px (the
    // "squeeze" layout — html/body are overflow:hidden there) and falls back to native
    // document scrolling below that, same breakpoint `scroll-container.js` uses
    // elsewhere. window.scrollY never changes in the squeeze layout, so it — and a
    // plain window scroll listener — silently do nothing at that width. Mirrored here
    // instead of imported: this inline script block doesn't support ES module imports.
    var SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');
    function getScrollContainer() {
      if (SQUEEZE_QUERY.matches) {
        return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
      }
      return document.scrollingElement || document.documentElement;
    }
    function getScrollTop() {
      return getScrollContainer().scrollTop;
    }
    function getScrollEventTarget() {
      if (SQUEEZE_QUERY.matches) {
        return document.querySelector('.page-wrapper') || document;
      }
      return document;
    }

    var main = document.getElementById('MainContent');
    if (!main) return;

    var chapters = Array.prototype.filter.call(main.children, function (el) {
      return el.classList.contains('shopify-section');
    });
    if (!chapters.length) return;

    var contentEls = [];
    var mediaEls = [];
    var tintEls = [];

    chapters.forEach(function (chapter) {
      var content = chapter.querySelector('.media-with-content__content, .section-content-wrapper');
      var mediaContainer = chapter.querySelector('.media-block, .background-image-container');
      var media = mediaContainer
        ? mediaContainer.querySelector(
            '.media-block__media, .background-image-container img, .background-image-container video, .background-image-container svg'
          )
        : null;

      if (content) {
        content.classList.add('story-chapter__content');
        contentEls.push(content);
      }

      if (mediaContainer) {
        var tint = document.createElement('div');
        tint.className = 'story-chapter__tint';
        mediaContainer.appendChild(tint);
        tintEls.push(tint);

        if (media && isDesktop && !prefersReducedMotion) {
          // Buffer the media beyond its container so the parallax translate below
          // never exposes an edge — both container types already clip overflow.
          media.style.height = '116%';
          media.style.top = '-8%';
          mediaEls.push({ el: media, container: mediaContainer });
        }
      }
    });

    // Reveal: each section's content fades in and rises up once, the first time it enters
    // the viewport — same one-shot IntersectionObserver pattern used by the trust badges
    // section. Reduced-motion visitors, and any environment without IntersectionObserver,
    // get the static content as-is — it's visible by default, so simply not hiding it here
    // is the fallback.
    if (!prefersReducedMotion && typeof IntersectionObserver !== 'undefined') {
      contentEls.forEach(function (el) {
        el.classList.add('story-chapter__content--pending');
      });
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('story-chapter__content--pending');
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );
      contentEls.forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    // Parallax + mood tint are motion effects tied to continuous scroll position,
    // so they're skipped entirely under reduced motion or on small screens.
    if (prefersReducedMotion || !isDesktop || chapters.length < 2 || !mediaEls.length) return;

    var maxTintOpacity = 0.35;
    var firstChapter = chapters[0];
    var lastChapter = chapters[chapters.length - 1];
    var ticking = false;

    function update() {
      ticking = false;

      var scrollTop = getScrollTop();
      var viewportCenter = scrollTop + window.innerHeight / 2;

      // Parallax: shift each chapter's media opposite to scroll, proportional to how
      // far its container's center is from the viewport center, clamped to stay subtle.
      mediaEls.forEach(function (entry) {
        var rect = entry.container.getBoundingClientRect();
        var containerCenter = rect.top + scrollTop + rect.height / 2;
        var distance = viewportCenter - containerCenter;
        var offset = Math.max(-40, Math.min(40, distance * 0.08));
        entry.el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });

      // Mood tint: interpolate a single opacity across the whole story arc based on
      // scroll position — heaviest at the opening, clearing by the closing CTA — and
      // apply it uniformly (only the section actually in view is seen anyway).
      var firstRect = firstChapter.getBoundingClientRect();
      var firstCenter = firstRect.top + scrollTop + firstRect.height / 2;
      var lastRect = lastChapter.getBoundingClientRect();
      var lastCenter = lastRect.top + scrollTop + lastRect.height / 2;
      var totalRange = Math.max(1, lastCenter - firstCenter);
      var progress = Math.max(0, Math.min(1, (viewportCenter - firstCenter) / totalRange));
      var opacity = maxTintOpacity * (1 - progress);

      tintEls.forEach(function (tint) {
        tint.style.opacity = opacity.toFixed(3);
      });
    }

    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    getScrollEventTarget().addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badges"] && !Shopify.designMode) return;
  try {
    
  class TrustBadgesReveal extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-initialized')) return;
      this.setAttribute('data-initialized', 'true');

      this.items = Array.from(this.children);
      if (!this.items.length) return;

      // Reduced-motion visitors, and any environment without IntersectionObserver, get the
      // static content as-is — items are visible by default, so simply not hiding them here
      // is the fallback (no separate CSS override needed).
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (typeof IntersectionObserver === 'undefined') return;

      this.staggerMs = Number(this.dataset.staggerMs) || 130;

      this.items.forEach((item) => item.classList.add('trust-badges__item--pending'));

      this.triggered = false;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (this.triggered || !entries[0]?.isIntersecting) return;
          this.triggered = true;
          this.observer.disconnect();
          this.#reveal();
        },
        { threshold: 0.2 }
      );
      this.observer.observe(this);
    }

    #reveal() {
      this.items.forEach((item, index) => {
        setTimeout(() => {
          item.classList.remove('trust-badges__item--pending');
        }, index * this.staggerMs);
      });
    }
  }

  if (!customElements.get('trust-badges-reveal')) {
    customElements.define('trust-badges-reveal', TrustBadgesReveal);
  }

  } catch(e) { console.error(e); }
})();
})();
